import { addDays } from '@Engage.Core';
import { StorageKeys, NewsletterStorageKey } from '@Engage.Data/constants/Constants';
import { CookiesStorageService } from './cookies/CookiesStorageService';
import { localStorageService } from './localStorage/LocalStorageService';
/**
 * Manages newsletter preference storage.
 * Uses igm_epref cookie (root domain, 45-day expiry) — matches ConneXt v2.
 */
export class NewsletterStorage {
    static setPreferenceIds(ids, days = 45) {
        CookiesStorageService.set(StorageKeys.EmailPreference, ids.join(','), {
            expandKey: false,
            useRootDomain: true,
            expires: addDays(days)
        });
    }
    static getPreferenceIds() {
        const raw = CookiesStorageService.get(StorageKeys.EmailPreference, {
            expandKey: false,
            useRootDomain: true
        });
        if (!raw)
            return [];
        return String(raw).split(',').map(Number).filter(n => !isNaN(n) && n > 0);
    }
    static mergePreferenceIds(newIds) {
        const existing = this.getPreferenceIds();
        const merged = Array.from(new Set([...existing, ...newIds]));
        this.setPreferenceIds(merged);
    }
    static isSubscribedToAll(preferenceIds) {
        if (!(preferenceIds === null || preferenceIds === void 0 ? void 0 : preferenceIds.length))
            return false;
        const stored = this.getPreferenceIds();
        return preferenceIds.every(id => stored.includes(id));
    }
    static setNewsletterSource(value) {
        CookiesStorageService.set(NewsletterStorageKey.NewsletterSource, value, {
            useRootDomain: true,
            expandKey: false
        });
    }
    static getNewsletterSource() {
        return CookiesStorageService.get(NewsletterStorageKey.NewsletterSource, { expandKey: false });
    }
    static setNewsletterReader(value) {
        localStorageService.set(NewsletterStorageKey.NewsletterReader, value, { expandKey: false });
    }
    static getNewsletterReader() {
        return localStorageService.get(NewsletterStorageKey.NewsletterReader, { expandKey: false });
    }
    // Mirrors Connext v2 ClientModule.setNewsletterNW → ClientNewsletterRepository.setNewsLetterNW
    static setNewsletterNW(value) {
        CookiesStorageService.set(NewsletterStorageKey.NewsletterNW, String(value), {
            expandKey: false,
            useRootDomain: false
        });
    }
}
